<template>
  <div class="auth-wrapper auth-v2 fullscreen">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <img :src="$i18n.locale === 'en' ? '//soustitreur.com/images/logo/logo-closedCaptioner.svg' : '//soustitreur.com/images/logo/logo.png'" style="height:220px;">
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        lg="4"
        class="d-flex auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <!-- Locale -->
          <div
            class="horizontal-layout"
            style="height:inherit"
          >
            <div class="navbar-container d-flex content align-items-center">
              <b-navbar-nav class="nav align-items-center ml-auto">
                <locale />
              </b-navbar-nav>
            </div>
          </div>
          <!-- /Locale -->
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('Forgot password?')}}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t("To receive a link to reset your password, please enter your email address.") }}
          </b-card-text>

          <!-- form -->
          <validation-observer
              ref="forgotPasswordForm"
              #default="{invalid}"
          >
            <b-form
              
              class="auth-forgot-password-form mt-2"
              @submit.prevent="resetPassword"
            >
              <b-form-group
                :label="$t('Email')"
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="forgot-password-email"
                    placeholder="john@example.com"
                    ref="refEmail"
                  />
                  <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':'Email'}) }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                :disabled="invalid"
                type="submit"
                variant="primary"
                block
              >
                {{ $t('Send reset link') }}
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'Login'}">
              <feather-icon icon="ChevronLeftIcon" /> {{ $t('Back to login') }}
            </b-link>
          </p>
          
        </b-col>
      </b-col>
    <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BForm, BFormGroup, BFormInput, BButton, BNavbarNav,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Locale from '@/components/header/Locale.vue'
import Apicall from '@/libs/api-call' 
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    ValidationProvider,
    ValidationObserver,
    Locale,
    BNavbarNav,
    ToastificationContent,
  },
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      // validation rules
      required,
      email,
      isloading: false,
      isCorrectToken: {},
    }
  },
  mounted() {
    this.getGeoInfo();
  },
  methods: {
    getGeoInfo() {
      this.$http.get('https://gapps.soustitreur.com/').then(res => { this.geoinfo = res.data; })
    },
    resetPassword() {
      this.$refs.forgotPasswordForm.validate().then(success => {
        if (success) {
          const api = new Apicall();
          this.isloading = true;
          api.forgotPassword(this.userEmail, this.$i18n.locale, location.hostname, this.geoinfo).then((response) => {
              if (response.status === 'OK') {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('Thanks! If there\'s an account associated with this email, we\'ll send the password reset instructions immediately.'),
                    icon: 'CoffeeIcon',
                    variant: 'success',
                  },
                })
              } else {
                  const errorData = {email: [this.$t(response.msg)]};
                  this.$refs.forgotPasswordForm.setErrors(errorData);
                  this.$refs.refEmail.focus();
              }
              this.isloading = false;
          }).catch((response) => {
            const errorData = {email: [this.$t(response.msg)]}
              this.$refs.loginForm.setErrors(errorData)
          });
        }
      })
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.fullscreen {
  background-image: linear-gradient(90deg, #b6fdb2 0%, #b6fdb2 50%, #EBFFEB 100%);
}
html[dir=ltr] .content {
    margin-left: 0px;
}
</style>
